import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useQuotesService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { ChartPeriodClickArgs } from "models/propTypes/chartProps";
//#endregion

const QuotesTotalByMonthChart: React.FC = () => {
  const quotesService = useQuotesService();
  const labelFormatter = (label?: string) => (label ? label.substring(0, 3) : "");

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.QuotesComparableMonthWidget}
      accumulatedChartAPIKey={GraphConstants.ChartKeys.QuotesComparableAccLineWidget}
      labelFormatter={labelFormatter}
      filterToAPIHandler={quotesService.reportToAPIFilter}
      usePageFilter={false}
      useClickableChart
      onDataPointClickedSetFilter={(arg) => {
        const args = arg as ChartPeriodClickArgs | undefined;
        return args?.start && args?.end ? { date: { start: args.start, end: args.end } } : {}
      }}
      onBackgroundClickedSetFilter={{ date: undefined }}
    />
  );
};

export default QuotesTotalByMonthChart;
